import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { PlayerWordlist } from '@/templates/slplus/structure/questionModels'
import { soundIsPlaying, stopSounds } from '@/utilities'
import Avatar from '@/components/base/Avatar.vue'
import Button from '@/components/base/Button.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerReady',
  props: {
  playerwordlist: {
    type: Object as PropType<PlayerWordlist>,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
},
  emits: ['playwordagain'],
  setup(__props, { expose }) {
  expose();




const __returned__ = { soundIsPlaying, stopSounds, Avatar, Button }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})